import { createInMemoryAtom, difference } from '@exodus/atoms';
const MAX_ENTRIES = 10;
const createLockHistoryAtom = ({ lockedAtom }) => {
    const lockHistory = createInMemoryAtom({
        defaultValue: [],
    });
    difference(lockedAtom).observe(async ({ current: locked }) => {
        await lockHistory.set((current) => [{ locked, timestamp: new Date() }, ...current].slice(0, MAX_ENTRIES));
    });
    return lockHistory;
};
export default createLockHistoryAtom;
